<template>
  <el-dialog
    :title="dialogType === 'create' ? 'Sor hozzáadása' : 'Sor szerkesztése'"
    :append-to-body="true"
    :visible="true"
    :close-on-click-modal="false"
    width="600px"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :rules="rules"
      :model="item"
      label-position="top"
    >
      <el-form-item
        label="Termék"
        prop="product_id"
      >
        <el-select
          v-model="item.product_id"
          :disabled="!itemDetailsEditable"  
          ref="productSelect"
          filterable
          :remote="true"
          :remote-method="value => search('products', `?name=${value}`)"
          :loading="productsLoading"
          placeholder="Gépelj a kereséshez..."
          loading-text="Termékek betöltése..."
          style="width: 100%;"
          @change="onProductChange"
        >
          <el-option
            v-for="p in products"
            :key="p.id"
            :value="p.id"
            :label="p.name"
          />
        </el-select>
      </el-form-item>

      <el-row :gutter="20">

        <el-col :span="12">
          <el-form-item
            label="Beszállító"
            prop="supplier_id"
          >
            <el-select
              v-loading="suppliersLoading"
              v-model="item.supplier_id"
              :disabled="!itemDetailsEditable"  
              filterable
              style="width: 100%;"
            >
              <el-option
                v-for="s in suppliers"
                :key="s.id"
                :value="s.id"
                :label="s.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Szavatossági idő" prop="expiration_date">
            <el-date-picker
              v-model="item.expiration_date"
              format="yyyy. MM. dd."
              :disabled="!itemDetailsEditable"  
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Mennyiségi egység" prop="product_pack_type_id">
            <el-select
              v-loading="packLoading"
              v-model="item.product_pack_type_id"
              :disabled="!itemDetailsEditable"  
              filterable
              style="width: 100%;"
            >
              <el-option
                v-for="unit in packTypes"
                :key="unit.id"
                :value="unit.id"
                :label="`${unit.pack_type_name} (${unit.count_per_pack})`"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mennyiség" prop="count">
            <el-input-number
              v-model="item.count"
              :disabled="!itemDetailsEditable"  
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="Beszer. ár/db" prop="purchase_unit_price">
        <el-input
          :disabled="!purchaseUnitPriceEditable"
          v-loading="priceLoading"
          v-model="item.purchase_unit_price"
        >
          <template slot="append">{{ currency }}</template>
        </el-input>
      </el-form-item>

      <el-form-item label="Megjegyzés" prop="comment">
        <el-input
          v-model="item.comment"
          :disabled="!itemDetailsEditable"  
          type="textarea"
          :rows="3"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    currency: {
      default: 'HUF'
    },
    itemToModify: {
      default: null
    },
    purchaseUnitPriceEditable: {
      required: true
    },
    itemDetailsEditable: {
      required: true
    }
  },
  data() {
    return {
      defaultItem: {
        product_id: 0,
        name: '',
        supplier_id: 0,
        supplier_name: '',
        product_pack_type_id: 0,
        pack_type_name: '',
        expiration_date: '',
        count: 0,
        base_count: 0,
        comment: '',
        purchase_unit_price: 0,
      },
      item: {
      },
      rules: {
        product_id: [{required: true, message: 'Termék kiválasztása kötelező'}],
        supplier_id: [{required: true, message: 'Beszállító kiválasztása kötelező'}],
        product_pack_type_id: [{required: true, message: 'Kiszerelés kiválasztása kötelező'}],
        expiration_date: [{required: true, message: 'Szavatossági idő megadása kötelező'}],
        count: [{required: true, message: 'Mennyiség megadása kötelező', trigger: 'blur'}],
      },
      dialogType: this.itemToModify ? 'update' : 'create',
      productsLoading: false,
      suppliersLoading: false,
      packLoading: false,
      priceLoading: false,
      loading: false,
      originalUnitPrice: 0,
      products: [],
      suppliers: [],
      packTypes: [],
    };
  },
  created () {
    this.onOpen()
  },
  mounted () {
    if (this.dialogType === 'create') {
        this.$nextTick(() => this.$refs.productSelect.focus())
    }
  },
  methods: {
    store() {
      this.$refs['form'].validate(valid => {
        if (!valid) {
            return
        }

        this.item.supplier_name = this.item.supplier_id && this.suppliers && this.suppliers.length
          ? this.suppliers.find(partner => partner.id === this.item.supplier_id).name
          : ''

        const packType = this.item.product_pack_type_id && this.packTypes && this.packTypes.length
          ? this.packTypes.find(packType => packType.id === this.item.product_pack_type_id)
          : null

        this.item.pack_type_name = packType 
          ? packType.pack_type_name // `${packType.pack_type_name} (${packType.count_per_pack})` 
          : ''

        let lineItemName = this.item.product_name;
        lineItemName = this.products.find(product => product.id === this.item.product_id).name;
        this.item.name = lineItemName;

        this.$emit('save', Object.assign({...this.defaultItem}, {...this.item}));
        if (this.dialogType === 'update') {
          this.$emit('close');
        } else {
          this.item = {}
          this.$refs.form.resetFields()
          this.$refs.productSelect.focus()
          this.$message({
            message: 'Termék hozzáadva',
            type: 'success'
          })
        }
      })
    },
    async fetchPacks(selected = 0) {
      this.packLoading = true;
      this.packTypes = await axios.get(`api/product-pack-types/${this.item.product_id}`);
      if (this.packTypes && this.packTypes.length) {
        let biggestPackTypeIdx = 0
        for (let i in this.packTypes) {
          if (this.packTypes[biggestPackTypeIdx].count_per_pack < this.packTypes[i].count_per_pack) {
            biggestPackTypeIdx = i
          }
        }
        this.$set(this.item, 'product_pack_type_id', selected ? selected : this.packTypes[biggestPackTypeIdx].id)
      } else {
        this.$set(this.item, 'product_pack_type_id', null)
      }

      this.packLoading = false;
    },
    async onProductChange(value) {
      await this.fetchPacks();
      await this.fetchSuppliers();
    },
    async fetchSuppliers(selected = 0) {
      this.suppliersLoading = true;
      const suppliers = await axios.get(`api/search/suppliers/${this.item.product_id}`);
      this.suppliers = suppliers;

      if (suppliers && suppliers.length) {
        this.$set(this.item, 'supplier_id', selected ? selected : suppliers[0].id)
      } else {
        this.$set(this.item, 'supplier_id', null)
      }

      this.suppliersLoading = false;
    },
    async onOpen() {
      this.loading = true
      if (this.itemToModify) {
        this.item = {...this.itemToModify}
        this.products = [{ id: this.item.product_id, name: this.item.name }]
        await this.fetchPacks(this.itemToModify.product_pack_type_id)
        await this.fetchSuppliers(this.itemToModify.supplier_id)
      }
      this.loading = false
    },
    async search(resource, query) {
      if (query !== '') {
        this[`${resource}Loading`] = true;
        this[resource] = await axios.get(`api/search/${resource}${query}`);
        this[`${resource}Loading`] = false;
      }
    },
  },
};
</script>
